<template>
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">Game Leaderboard</h1>
      <breadcrumb name="GAME_LEADER_BOARD_CAMPAIGN"></breadcrumb>
      <div class="page-header-actions">
        <button
          type="button"
          class="btn btn-icon btn-dark btn-outline btn-round mx-10"
          @click="reloadTable"
        >
          <i class="icon md-refresh-alt" aria-hidden="true"></i> Reload table
        </button>

        <button
          type="button"
          class="btn btn-round btn-dark btn-outline mx-10"
          @click="hideArchive = !hideArchive"
        >
          {{ hideArchive ? "Show all" : "Hide Archive" }}
        </button>

        <button
          type="button"
          class="btn btn-round btn-primary"
          @click="openCreateModal"
        >
          <i class="icon md-plus" aria-hidden="true"></i> Create
        </button>
      </div>
    </div>
    <div class="page-content page-content-table">
      <div class="container-fluid">
        <div class="panel">
          <div class="panel-body p-0">
            <vue-good-table
              ref="table"
              :rows="campaigns"
              :columns="columns"
              @on-row-click="onRowClick"
              :sort-options="sortOption"
              :search-options="searchOption"
              :pagination-options="pagination"
              @on-search="onSearch"
              @on-sort-change="onSortChange"
              @on-page-change="onPageChange"
              @on-per-page-change="onPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <div v-if="props.column.field == 'status'">
                  {{ props.row.status | toUpperCase }}
                </div>
                <div v-else-if="props.column.field == 'end_date'">
                  {{ props.row.end_date == null ? "n/a" : props.row.end_date }}
                </div>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <modal name="create-modal" :width="450" height="auto">
      <CreateModal @submit="fetchcampaign" />
    </modal>
  </div>
</template>

<script>
import { leaderBoardService } from "@/api/client";
import vueGoodTableMixins from "@/mixins/vue-good-table";
import CreateModal from "@/views/leaderboard/campaign/CreateModal.vue";
import { campaignTableColumns } from "@/views/leaderboard/campaign/model";

export default {
  name: "CampaignList",

  mixins: [vueGoodTableMixins],

  data() {
    return {
      campaigns: [],
      hideArchive: true,
      columns: campaignTableColumns,
    };
  },

  components: { CreateModal },

  created() {
    this.fetchcampaign();
  },

  watch: {
    hideArchive() {
      this.filter();
    },
  },

  beforeMount() {
    this.initialTableState();
  },

  mounted() {
    this.initialTableSearchState();
  },

  methods: {
    onRowClick(event) {
      this.$router
        .push({
          name: "leaderboard-campaign-edit",
          params: { id: event.row.id },
        })
        .catch((err) => {});
    },

    async fetchcampaign(show_all) {
      this.campaigns = await leaderBoardService.getCampaignList({
        show_all: show_all,
      });
    },

    filter() {
      this.hideArchive ? this.fetchcampaign(0) : this.fetchcampaign(1);
    },

    async reloadTable() {
      await this.fetchcampaign();
      this.$notify("Updated");
    },

    async openCreateModal() {
      this.$modal.show(`create-modal`);
    },
  },
};
</script>

<style lang="scss">
table.vgt-table tr {
  cursor: pointer;
  &:hover {
    background-color: #f1f1f1;
  }
}
</style>
